<template>
    <div class="search-menu">
        <button class="search-button" @click="toggleMenu()">
            <div class="col-sm-6 col-md-4 col-lg-3">
                <i class="fas fa-solid fa-search"></i>
            </div>
        </button>

        <div v-if="showMenu" class="dropdown-search">
            <div v-for="(option, index) in searchOptions" :key="index" class="dropdown-search-item"
                @click="selectOption(option)">
                <div class="label">{{ option.label }}</div>
                <img :src="option.icon" alt="icon" />
            </div>
        </div>

        <div v-else-if="selectedOption" class="search-form">
            <div class="search-title">
                <img :src="selectedOption.icon" alt="icon" />
                <div class="label">
                    {{ selectedOption.label }}
                </div>
            </div>
            <div class="search-input-button">
                <template v-if="selectedOption.key === 'status'">
                    <select
                        v-model="searchQuery"
                        class="custom-select"
                        :style="{
                            backgroundImage: `url(${selectDropdownIcon})`
                        }"
                    >
                        <option value="">Todos</option>
                        <option
                            v-for="status in filteredStatusOptions"
                            :key="status.value"
                            :value="status.value"
                        >
                            {{ status.label }}
                        </option>
                    </select>
                </template>

                <template v-else>
                    <input 
                        :type="selectedOption.key === 'seller_id' ? 'number' : 'text'" 
                        :placeholder="selectedOption.placeholder" 
                        v-model="searchQuery"
                        @input="selectedOption.key === 'seller_id' ? onlyNumbers($event) : null"
                    />
                </template>
                <div class="actions-search">
                    <button @click="cancelSearch">Cancelar</button>
                    <button @click="doSearch(selectedOption)">Buscar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import emailIcon from '@src/assets/img/icons/email.svg';
import clientIcon from '@src/assets/img/icons/client.svg';
import documentIcon from '@src/assets/img/icons/document.svg';
import analystIcon from '@src/assets/img/icons/cpf.svg';
import statusIcon from '@src/assets/img/icons/status.svg';
import hashtagIcon from '@src/assets/img/icons/hashtag.svg';
import { mapGetters } from 'vuex'


export default {
    props: {
        tabIndex: {
            type: Number,
            required: true,
        }
    },

    data() {
        return {
            selectDropdownIcon: require('@src/assets/img/icons/select-dropdown.svg'),
            options: [
                { label: 'E-mail do produtor', key: 'seller_email', icon: emailIcon, placeholder: 'Buscar e-mail' },
                { label: 'Nome do produtor', key: 'seller_name', icon: clientIcon, placeholder: 'Buscar nome' },
                { label: 'Documento do produtor', key: 'seller_document', icon: documentIcon, placeholder: 'Buscar documento' },
                { label: 'Status do saque', key: 'status', icon: statusIcon, placeholder: 'Selecione o status' },
            ],
            selectedOption: null,
            searchQuery: '',
            showMenu: false,
        }
    },

    computed: {
        ...mapGetters([
            'statusOptions'
        ]),

        searchOptions() {
            const options = [
                { label: 'ID do produtor', key: 'seller_id', icon: hashtagIcon, placeholder: 'Buscar ID' },
                { label: 'E-mail do produtor', key: 'seller_email', icon: emailIcon, placeholder: 'Buscar e-mail' },
                { label: 'Nome do produtor', key: 'seller_name', icon: clientIcon, placeholder: 'Buscar nome' },
                { label: 'Documento do produtor', key: 'seller_document', icon: documentIcon, placeholder: 'Buscar documento' },
                { label: 'Analista', key: 'analyst_name', icon: analystIcon, placeholder: 'Buscar por analista' },
            ];

            if (this.tabIndex !== 1) {
                options.push({
                    label: 'Status do saque',
                    key: 'status',
                    icon: statusIcon,
                    placeholder: 'Selecione o status'
                });
            }

            return options;
        },

        filteredStatusOptions() {
            return (this.statusOptions || []).filter(option =>
                this.isValidStatusOption(option)
            );
        },

    },

    methods: {
        toggleMenu() {
            if (this.selectedOption) {
                this.selectedOption = null
                this.showMenu = false;
                return;
            }
            this.showMenu = !this.showMenu;
        },
        resetSelectedOption() {
            this.selectedOption = null
        },
        selectOption(option) {
            this.showMenu = false;
            this.selectedOption = option
            this.searchQuery = ''
        },
        cancelSearch() {
            this.showMenu = true;
            this.selectedOption = null
        },
        doSearch(selectedOption) {            
            this.selectedOption = null
            this.showMenu = false;

            this.$store.commit('RESET_ALL_WITHDRAWAL_ITEMS');

            this.$emit('search', {
                key: selectedOption.key,
                value: this.searchQuery
            });
        },
        isValidStatusOption(option) {
            return option.value !== 'ANALYZE';
        },
        onlyNumbers(event) {
            const value = event.target.value;
            event.target.value = value.replace(/\D/g, '');
            this.searchQuery = event.target.value;
        },
    },
}
</script>

<style scoped lang="scss">
.search-menu {
    .search-button {
        border: none;
        border-radius: 8px;
        background-color: #FFF;

        img {
            width: 40px;
            height: 40px;
        }
    }

    .dropdown-search {
        display: flex;
        width: max-content;
        flex-direction: column;
        border-radius: 10px;
        border: 1px solid var(--Gray-50, #E5E7E7);
        background: var(--Gray-white, #FFF);
        box-shadow: 2px 4px 16px 0px rgba(0, 0, 0, 0.05);
        position: absolute;
        z-index: 10;

        .dropdown-search-item {
            display: flex;
            justify-content: space-between;
            padding: 20px 20px;
            align-items: center;
            font-size: 14px;
            gap: 30px;
            font-weight: 500;
            color: #1D1D1D;
            cursor: pointer;
            transition: background 0.2s;

            .label {
                color: var(--Gray-500, #000C0B);
                font-family: "Plus Jakarta Sans";
                font-size: 14px;
                font-weight: 400;
            }

            &:hover {
                background-color: #F5F5F5;
            }
        }
    }
    .custom-select {
        width: 13.5625rem;
        height: 2.5rem;
        flex-shrink: 0;
        border-radius: 0.3125rem;
        border: 1px solid var(--Gray-50, #E5E7E7);
        padding: 0 2.5rem 0 0.75rem;
        appearance: none;
        background-color: #FFF;
        background-repeat: no-repeat;
        background-position: right 0.75rem center;
        background-size: 1rem;
        font-size: 14px;
        font-family: "Plus Jakarta Sans", sans-serif;
    }
    .search-form {
        display: flex;
        flex-direction: column;
        width: max-content;
        padding: 25px 28px;
        border-radius: 10px;
        border: 1px solid var(--Gray-50, #E5E7E7);
        background: var(--Gray-white, #FFF);
        box-shadow: 2px 4px 16px 0px rgba(0, 0, 0, 0.05);
        position: absolute;
        z-index: 10;
        gap: 25px;

        .search-title {
            display: flex;
            gap: 16px;

            .label {
                color: var(--Gray-500, #000C0B);
                font-family: "Plus Jakarta Sans";
                font-size: 15px;
                font-weight: 700;
            }
        }

        .search-input-button {
            display: flex;
            flex-direction: column;
            gap: 8px;

            input {
                border-radius: 5px;
                border: 1px solid var(--Gray-50, #E5E7E7);
                padding: 10px 12px;
                font-size: 14px;
            }

            .actions-search {
                display: flex;
                gap: 7px;

                button {
                    font-family: "Plus Jakarta Sans";
                    font-size: 13px;
                    font-weight: 600;
                    flex: 1;
                    padding: 10px 0;
                    cursor: pointer;
                    border: none;
                    border-radius: 5px;

                    &:first-child {
                        background: var(--Gray-10, #F0F2F5);
                        color: var(--Gray-500, #000C0B);
                    }

                    &:last-child {
                        background: var(--Gray-500, #000C0B);
                        color: var(--Gray-white, #FFF);
                    }
                }
            }
        }
    }
}
</style>